// POC1
import React, { useCallback, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import MessageModal from '@wix/da-ds/pkg/modals/dsPresets/MessageModal';
import { DestructiveConfirmButton, ConfirmButton, CancelButton, } from '@wix/da-ds/pkg/modals/dsPresets/MessageModal/buttons';
import s from './ConfirmationModal.scss';
var ConfirmationModal = function (_a) {
    var _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, title = _a.title, text = _a.text, icon = _a.icon, _c = _a.withCancelButton, withCancelButton = _c === void 0 ? true : _c, cancelBtnLabel = _a.cancelBtnLabel, cancelBtnBiData = _a.cancelBtnBiData, confirmBtnLabel = _a.confirmBtnLabel, _d = _a.confirmBtnType, confirmBtnType = _d === void 0 ? 'default' : _d, confirmBtnBiData = _a.confirmBtnBiData, onCancel = _a.onCancel, onConfirm = _a.onConfirm, doNotShowAgainKey = _a.doNotShowAgainKey, onDoNotShowAgainChange = _a.onDoNotShowAgainChange, autoAcceptForDoNotShow = _a.autoAcceptForDoNotShow;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var doNotShowHandler = useCallback(function (value) {
        if (!doNotShowAgainKey) {
            return;
        }
        onDoNotShowAgainChange &&
            onDoNotShowAgainChange(doNotShowAgainKey, value);
    }, [doNotShowAgainKey, onDoNotShowAgainChange]);
    useEffect(function () {
        if (onConfirm && isOpen && autoAcceptForDoNotShow === true) {
            onConfirm();
        }
    }, [isOpen, autoAcceptForDoNotShow, onConfirm]);
    if (autoAcceptForDoNotShow) {
        return null;
    }
    return (React.createElement(MessageModal, { isOpen: isOpen, title: title, message: text, className: s['root'], variant: isMobile ? 'vertical' : 'horizontal', image: icon, footerButtons: [
            withCancelButton && (React.createElement(CancelButton, { key: "cancel", onClick: onCancel, biData: cancelBtnBiData }, cancelBtnLabel !== null && cancelBtnLabel !== void 0 ? cancelBtnLabel : t('popup.cancel'))),
            confirmBtnType === 'danger' ? (React.createElement(DestructiveConfirmButton, { key: "danger-confirm", onClick: onConfirm, biData: confirmBtnBiData }, confirmBtnLabel)) : (React.createElement(ConfirmButton, { key: "confirm", onClick: onConfirm, biData: confirmBtnBiData }, confirmBtnLabel)),
        ], onRequestClose: onCancel !== null && onCancel !== void 0 ? onCancel : onConfirm, doNotShowAgainText: t('popup.doNotShowAgain'), onDoNotShowAgainChange: doNotShowAgainKey ? doNotShowHandler : undefined }));
};
ConfirmationModal.displayName = 'ConfirmationModal';
export default ConfirmationModal;
//# sourceMappingURL=ConfirmationModal.js.map